import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { Anchor, ButtonSubmit, Form } from '@anytag/shared-atoms';
import { useAllAvailableCountryOptions } from '@anytag/shared-hooks';
import { SelectorField, TextField } from '@anytag/shared-molecules';
import { cn } from '@anytag/shared-utils';
import { SignUpFormValues, SignUpFormKeys } from './types';

export const Template = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const {
    getValues,
    formState: { isSubmitting }
  } = useFormContext<SignUpFormValues>();
  const { allAvailableCountryOptions } = useAllAvailableCountryOptions();

  const values = getValues();
  const hasAllFieldFilled = Object.values(values).every((field) => !!field);

  return (
    <Form.Body className={cn('p-0 px-10 py-12 shadow-none', className)}>
      <h1 className="text-center text-xl leading-[100%]">{t('Sign up')}</h1>

      <p className="my-4 text-center text-base leading-[140%]">
        <Trans i18nKey="SignUp.Description" components={{ br: <br /> }} />
      </p>

      <TextField<SignUpFormKeys>
        name="companyName"
        title={t('TextForm.Company Name')}
        placeholder={t<string>('Company Name')}
        required
      />

      <TextField<SignUpFormKeys>
        name="companyUrl"
        title={t('TextForm.Company URL')}
        placeholder="https://anytag.tech"
        required
      />

      <Form.Fields itemsPerRow={2}>
        <TextField<SignUpFormKeys>
          name="phoneNumber"
          placeholder="066020485707"
          title={t('TextForm.Phone Number')}
          required
        />
        <SelectorField<SignUpFormKeys>
          name="countryId"
          title={t('Selector.Country')}
          options={allAvailableCountryOptions}
          required
        />
      </Form.Fields>

      <TextField<SignUpFormKeys> name="name" title={t('TextForm.Name')} placeholder={t<string>('Name')} required />
      <TextField<SignUpFormKeys> name="email" title={t('TextForm.Email')} placeholder="your@email.com" required />

      <ButtonSubmit
        loading={isSubmitting}
        disabled={!hasAllFieldFilled}
        title={t('Button.Create Account')}
        className="mt-4 w-full"
      />

      <p className="mt-6 text-[11px] leading-[140%] text-tertiary">
        <Trans
          i18nKey="SignUpConfirmation"
          components={{
            a1: <Anchor variant="blue" className="inline text-sm" to="/privacy" />,
            a2: <Anchor variant="blue" className="inline text-sm" to="/terms" />
          }}
        />
      </p>
    </Form.Body>
  );
};
